// classNames for table elements
export const cnTbl = 'tbl';

export const cnTblHead = 'th';
export const cnTblHeadRow = 'th__row';
export const cnTblHeadRowUnderlineLast = 'th__row--ul-last';
export const cnTblHeadCell = 'th__cell';
export const cnTblHeadCellWired = 'th__cell--wired';
export const cnTblHeadCellBold = 'th__cell--bold';
export const cnTblHeadCellDense = 'th__cell--dense';
export const cnTblHeadCellSortable = 'th__cell--sortable';

export const cnTblBody = 'tb';
export const cnTblBodyRow = 'tb__row';
export const cnTblBodyRowClickable = 'tb__row--clickable';
export const cnTblBodyRowUnderlineLast = 'tb__row--ul-last';
export const cnTblBodyRowAltColor = 'tb__row--alt-color';
export const cnTblBodyCell = 'tb__cell';
export const cnTblBodyCellWired = 'tb__cell--wired';
export const cnTblBodyCellDense = 'tb__cell--dense';

export const cnTblFoot = 'tf';
export const cnTblFootRow = 'tf__row';
export const cnTblFootCell = 'tf__cell';
export const cnTblFootCellDense = 'tf__cell--dense';

export const cnTblNoDataMessage = 'tbl__no-data-message';

export const cnTblPagination = 'tbl-pagination';
export const cnTblPaginationDataMessage = 'tbl-pagination__data-message';

export const cnTblAlteredCellContent = 'altered-cell-content';